import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import { useStyles } from './EmptyPlaylistSelection.jss';

interface EmptySelectionProps {
  title?: string;
  subtitle?: string;
}

export const EmptyPlaylistSelection = (props: EmptySelectionProps) => {
  const classes = useStyles();
  const [t] = useTranslation();
  return (
    <div className={classes.emptySelectionContainer}>
      <svg width="206" height="196" viewBox="0 0 206 196" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M199.5 104L201.537 99.515L206 97.5L201.537 95.485L199.5 91L197.507 95.485L193 97.5L197.507 99.515L199.5 104Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M46.5 125L48.5367 120.515L53 118.5L48.5367 116.485L46.5 112L44.5067 116.485L40 118.5L44.5067 120.515L46.5 125Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M131.5 36L133.537 31.515L138 29.5L133.537 27.485L131.5 23L129.507 27.485L125 29.5L129.507 31.515L131.5 36Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M186 48L188.507 42.48L194 40L188.507 37.52L186 32L183.547 37.52L178 40L183.547 42.48L186 48Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M133 196L135.507 190.48L141 188L135.507 185.52L133 180L130.547 185.52L125 188L130.547 190.48L133 196Z"
          className={classes.fadedColorFill}
        />
        <path d="M68 20L71.1333 13.1L78 10L71.1333 6.9L68 0L64.9333 6.9L58 10L64.9333 13.1L68 20Z" className={classes.secondaryColorFill} />
        <path
          d="M85.5 167L87.5367 162.515L92 160.5L87.5367 158.485L85.5 154L83.5067 158.485L79 160.5L83.5067 162.515L85.5 167Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M83 78L84.5667 74.55L88 73L84.5667 71.45L83 68L81.4667 71.45L78 73L81.4667 74.55L83 78Z"
          className={classes.fadedColorFill}
        />
        <path
          d="M28.5 174L30.2233 170.205L34 168.5L30.2233 166.795L28.5 163L26.8133 166.795L23 168.5L26.8133 170.205L28.5 174Z"
          className={classes.fadedColorFill}
        />
        <path d="M7 67L9.19333 62.17L14 60L9.19333 57.83L7 53L4.85333 57.83L0 60L4.85333 62.17L7 67Z" className={classes.fadedColorFill} />
        <path
          d="M148.5 125L150.223 121.205L154 119.5L150.223 117.795L148.5 114L146.813 117.795L143 119.5L146.813 121.205L148.5 125Z"
          className={classes.fadedColorFill}
        />
        <path d="M116.5 83L117 81L119 80.5L117 80L116.5 78L116 80L114 80.5L116 81L116.5 83Z" className={classes.fadedColorFill} />
        <g filter="url(#filter0_d)">
          <path
            d="M145 83.25V87H148.75L159.81 75.94L156.06 72.19L145 83.25ZM162.71 73.04C163.1 72.65 163.1 72.02 162.71 71.63L160.37 69.29C159.98 68.9 159.35 68.9 158.96 69.29L157.13 71.12L160.88 74.87L162.71 73.04Z"
            className={classes.baseColorFill}
          />
        </g>
        <g filter="url(#filter1_d)">
          <path
            d="M39 68C35.13 68 32 71.13 32 75C32 80.25 39 88 39 88C39 88 46 80.25 46 75C46 71.13 42.87 68 39 68ZM34 75C34 72.24 36.24 70 39 70C41.76 70 44 72.24 44 75C44 77.88 41.12 82.19 39 84.88C36.92 82.21 34 77.85 34 75Z"
            className={classes.baseColorFill}
          />
          <path
            d="M39 77.5C40.3807 77.5 41.5 76.3807 41.5 75C41.5 73.6193 40.3807 72.5 39 72.5C37.6193 72.5 36.5 73.6193 36.5 75C36.5 76.3807 37.6193 77.5 39 77.5Z"
            className={classes.baseColorFill}
          />
        </g>
        <g clip-path="url(#clip0)">
          <g filter="url(#filter2_d)">
            <path
              d="M25 146H23V148H25V146ZM29 146H27V148H29V146ZM33 146H31V148H33V146ZM35 139H34V137H32V139H24V137H22V139H21C19.89 139 19.01 139.9 19.01 141L19 155C19 156.1 19.89 157 21 157H35C36.1 157 37 156.1 37 155V141C37 139.9 36.1 139 35 139ZM35 155H21V144H35V155Z"
              className={classes.baseColorFill}
            />
          </g>
        </g>
        <g filter="url(#filter3_d)">
          <path
            d="M165 145V150L169.25 152.52L170.02 151.24L166.5 149.15V145H165ZM175 147V140L172.36 142.64C170.74 141.01 168.49 140 166 140C161.03 140 157 144.03 157 149C157 153.97 161.03 158 166 158C170.97 158 175 153.97 175 149H173C173 152.86 169.86 156 166 156C162.14 156 159 152.86 159 149C159 145.14 162.14 142 166 142C167.93 142 169.68 142.79 170.95 144.05L168 147H175Z"
            className={classes.baseColorFill}
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M115.221 48.9596C114.683 48.8349 114.145 49.17 114.021 49.7081C113.896 50.2461 114.231 50.7833 114.769 50.908C118.929 51.8716 122.954 53.1861 126.812 54.8185C127.321 55.0338 127.908 54.7959 128.123 54.2873C128.338 53.7786 128.1 53.1918 127.592 52.9766C123.629 51.2998 119.494 49.9495 115.221 48.9596ZM81.2307 50.908C81.7687 50.7833 82.1038 50.2461 81.9792 49.7081C81.8545 49.17 81.3173 48.8349 80.7793 48.9596C76.5063 49.9495 72.3713 51.2998 68.4081 52.9766C67.8995 53.1919 67.6617 53.7786 67.8769 54.2873C68.0921 54.7959 68.6789 55.0338 69.1875 54.8186C73.0456 53.1861 77.0709 51.8717 81.2307 50.908ZM137.252 57.9078C136.779 57.6221 136.164 57.7738 135.879 58.2464C135.593 58.7191 135.745 59.3339 136.217 59.6195C139.847 61.8127 143.272 64.3089 146.46 67.0731C146.877 67.4349 147.509 67.39 147.87 66.9728C148.232 66.5556 148.187 65.924 147.77 65.5622C144.497 62.7237 140.979 60.1602 137.252 57.9078ZM59.7827 59.6195C60.2554 59.3339 60.407 58.7191 60.1214 58.2464C59.8357 57.7738 59.221 57.6221 58.7483 57.9078C55.0209 60.1602 51.5028 62.7237 48.2298 65.5622C47.8126 65.924 47.7677 66.5556 48.1295 66.9728C48.4914 67.3901 49.1229 67.435 49.5402 67.0731C52.7275 64.3089 56.1534 61.8127 59.7827 59.6195ZM168.023 93.4082C167.808 92.8995 167.221 92.6617 166.713 92.8769C166.204 93.0921 165.966 93.6789 166.181 94.1875C167.814 98.0456 169.128 102.071 170.092 106.231C170.217 106.769 170.754 107.104 171.292 106.979C171.83 106.855 172.165 106.317 172.04 105.779C171.051 101.506 169.7 97.3713 168.023 93.4082ZM29.8185 94.1875C30.0338 93.6789 29.7959 93.0921 29.2873 92.8769C28.7786 92.6617 28.1918 92.8995 27.9766 93.4082C26.2998 97.3713 24.9495 101.506 23.9596 105.779C23.8349 106.317 24.17 106.855 24.7081 106.979C25.2461 107.104 25.7833 106.769 25.9079 106.231C26.8716 102.071 28.1861 98.0456 29.8185 94.1875ZM173.725 116.492C173.679 115.942 173.195 115.533 172.644 115.58C172.094 115.627 171.686 116.111 171.732 116.661C171.91 118.75 172 120.864 172 123C172 125.165 171.907 127.307 171.725 129.425C171.678 129.975 172.085 130.459 172.636 130.507C173.186 130.554 173.67 130.146 173.718 129.596C173.905 127.422 174 125.222 174 123C174 120.808 173.907 118.637 173.725 116.492ZM24.2676 116.661C24.3143 116.111 23.9061 115.627 23.3557 115.58C22.8054 115.533 22.3215 115.942 22.2748 116.492C22.0928 118.637 22 120.808 22 123C22 125.222 22.0954 127.422 22.2823 129.596C22.3296 130.146 22.814 130.554 23.3643 130.507C23.9146 130.459 24.3223 129.975 24.275 129.425C24.0929 127.307 24 125.165 24 123C24 120.864 24.0904 118.75 24.2676 116.661Z"
          className={classes.fadedColorFill}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M73.1667 126.875V125.583H68V123H75.75V133.333H68V130.75H73.1667V129.458H70.5833V126.875H73.1667ZM73.1667 102.333H70.5833V94.5833H68V92H73.1667V102.333ZM72.65 110.083H68V107.5H75.75V109.825L71.1 115.25H75.75V117.833H68V115.508L72.65 110.083ZM80.9167 99.75V94.5833H117.083V99.75H80.9167ZM97.2321 130.75H80.9167V125.583H99.9145C98.8139 127.172 97.9083 128.906 97.2321 130.75ZM117.083 115.25H80.9167V110.083H117.083V115.25Z"
          className={classes.primaryColorFill}
        />
        <path
          d="M118.833 120.667C108.897 120.667 100.833 128.731 100.833 138.667C100.833 148.603 108.897 156.667 118.833 156.667C128.769 156.667 136.833 148.603 136.833 138.667C136.833 128.731 128.769 120.667 118.833 120.667ZM115.233 146.767V130.567L126.033 138.667L115.233 146.767Z"
          className={classes.primaryColorFill}
        />
        <path
          d="M104 47V44L108 48L104 52V49H100V47H104ZM90 47V44L94 48L90 52V49H86V47H90ZM96 40H98V56H96V40Z"
          className={classes.baseColorFill}
        />
        <defs>
          <filter
            id="filter0_d"
            x="138"
            y="66"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter1_d"
            x="23"
            y="66"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter2_d"
            x="15"
            y="137"
            width="26"
            height="28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="filter3_d"
            x="150"
            y="137"
            width="32"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <clipPath id="clip0">
            <rect width="24" height="24" className={classes.baseColorFill} transform="translate(16 135)" />
          </clipPath>
        </defs>
      </svg>

      <Typography className={classes.emptySelectionMessage} variant="h5" align="center">
        {props.title ? t(props.title) : t('message.emptySelectionTitle')}
      </Typography>
      <Typography className={classes.emptySelectionSubMessage} variant="body1" align="center">
        {props.subtitle ? t(props.subtitle) : t('message.emptySelectionSubtitle')}
      </Typography>
    </div>
  );
};
